<template>
    <div class="tool">
        <div class="tool-hover" @mouseover="hover = true" @mouseleave="hover = false">
            <slot>
                <span class="tool-icon">?</span>
            </slot>
        </div>
        <div v-if="hover" class="tool-tip" :class="`tool-tip--${position}`" v-html="text" />
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: [String, Number],
            required: true,
        },
        position: {
            type: String,
            default: 'left'
        }
    },

    data() {
        return {
            hover: false,
        };
    },
};
</script>

<style lang="css" scoped>
    .tool {
        position: relative;
        color: #FFF;
        font-size: 13px;
        font-weight: 500;
    }

    .tool-hover {
        cursor: pointer;
    }

    .tool-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        width: 20px;
        height: 20px;
        background-color: rgba(0,0,0, 0.5);
        color: #FFF;
    }

    .tool-tip {
        position: absolute;
        width: 320px;
        right: -95px;
        bottom: 40px;
        text-align: center;
        border-radius: 5px;
        padding: 1em;
        background-color: rgba(0,0,0, 0.5);
        white-space: normal;
        z-index: 999;
    }

    .tool-tip::after {
        top: 100%;
        right: 30%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: transparent;
        border-top-color: rgba(0,0,0, 0.5);
        border-width: 10px;
        margin-left: -10px;
    }

    .tool-tip--right {
        right: auto;
        left: -95px;
    }

    .tool-tip--right::after {
        right: auto;
        left: 33%;
    }

    .tool-tip--center {
        left: 50%;
        transform: translateX(-50%);
    }

    .tool-tip--center::after {
        right: auto;
        left: 50%;
    }
</style>
